<template>
  <div class="caixa_dados defaultcolor" :class="colorclass">
    <h1 class="nome_sucesso">
      {{ nome }} -
      <span class="graduacao_curso_ano_mobile">{{ grau }} em {{ curso }} em {{ ano }}</span>
    </h1>
    <h1 class="graduacao_curso_ano">{{ grau }} em {{ curso }} em {{ ano }}</h1>
  </div>
</template>

<script>
export default {
  props: ["nome", "grau", "ano", "colorclass", "curso"],
};
</script>

<style scoped>
/**138 */
.linha_sucesso {
  border-top: 1px solid rgb(63, 66, 68);
  display: block;
}

/**143 */

.graduacao_curso_ano_mobile {
  display: none;
}

.nome_sucesso {
  text-align: left;
  font-family: "Montserrat SemiBold";
  display: inline-block;
  padding-left: 5px;
  color: #ffffff;
  font-size: 17px;
  padding-bottom: 5px;
  padding-top: 22px;
  letter-spacing: 0;
}

/**155 */
.graduacao_curso_ano {
  text-align: left;
  font-family: "Montserrat SemiBold";
  display: inline-block;
  padding-left: 5px;
  color: #ffffff;
  font-size: 17px;
  letter-spacing: 0;
}

/*442 */
.caixa_dados {
  padding-right: 14px;
  padding-left: 90px;
  border-radius: 0px 0px 8px 8px;
}

/**566 */
.graduacao_curso_ano_mobile {
    display: none;
}

@media (min-width: 768px) and (max-width: 1024px) {
  /**667 */
  .nome_sucesso {
    font-size: 16px;
    padding-left: 0px;
  }
  /**672 */
  .graduacao_curso_ano {
    font-size: 16px;
    padding-right: 0px;
  }

  .caixa_dados {
    padding-left: 40px;
  }
}

@media (max-width: 767px) {
  /**808 */

  .graduacao_curso_ano_mobile {
    display: block;
  }

  .graduacao_curso_ano {
    display: none;
  }

  .nome_sucesso {
    font-size: 14px;
    padding-left: 0px;
    padding-bottom: 0px;
  }

/**814 */
  .graduacao_curso_ano_mobile {
    font-size: 14px;
    padding-right: 0px;
    display: inline;
    line-height: 1;
  }

  /**822 */
  .nome_sucesso {
    padding-top: 0px;
    padding-bottom: 9px;
    padding-left: 5px;
    padding-bottom: 0px;
    line-height: 1;
    margin-bottom: 0px;
  }

  /**828 */

  .graduacao_curso_ano {
    font-size: 14px;
    padding-bottom: 0px;
    line-height: 1;
    padding-top: 0px;
    margin-bottom: 0px;

  }

  /*839*/
  .caixa_dados {
    padding-right: 5px;
    padding-left: 10px;
    line-height: 1;
    padding-top: 20px;
    padding-bottom: 10px;
  }

}
</style>
